module.exports = __webpack_public_path__ + "img/mohammed_mansur.212fcc06.webp";